<template>
  <textarea :name="name"></textarea>
</template>

<script>
export default {
  replace: true,
  inherit: false,
  // template: "<textarea class='form-control' :name='name'></textarea>",
  props: {
    value: {
      required: true
      // twoWay: true
    },

    language: {
      type: String,
      required: false,
      default: 'pt-BR'
    },

    height: {
      type: Number,
      required: false,
      default: 350
    },

    minHeight: {
      type: Number,
      required: false,
      default: 160
    },

    maxHeight: {
      type: Number,
      required: false,
      default: 800
    },

    name: {
      type: String,
      required: false,
      default: ''
    },

    toolbar: {
      type: Array,
      required: false,
      default () {
        return [
          ['font', ['bold', 'italic', 'underline', 'clear']],
          // ['fontsize', ['fontsize']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['color', ['color']],
          ['insert', ['link', 'hr']]
        ]
      }
    }
  },

  methods: {
    cleanPastedHTML (input) {
      // 1. remove line breaks / Mso classes
      var stringStripper = /(\n|\r| class=(")?Mso[a-zA-Z]+(")?)/g
      var output = input.replace(stringStripper, ' ')
      // 2. strip Word generated HTML comments
      var commentSripper = new RegExp('<!--(.*?)-->', 'g')
      output = output.replace(commentSripper, '')
      var tagStripper = new RegExp('<(/)*(meta|link|span|\\?xml:|st1:|o:|font)(.*?)>', 'gi')
      // 3. remove tags leave content if any
      output = output.replace(tagStripper, '')
      // 4. Remove everything in between and including tags '<style(.)style(.)>'
      var badTags = ['style', 'script', 'applet', 'embed', 'noframes', 'noscript']

      for (let i = 0; i < badTags.length; i++) {
        tagStripper = new RegExp('<' + badTags[i] + '.*?' + badTags[i] + '(.*?)>', 'gi')
        output = output.replace(tagStripper, '')
      }
      // 5. remove attributes ' style="..."'
      var badAttributes = ['style', 'start']
      for (let i = 0; i < badAttributes.length; i++) {
        var attributeStripper = new RegExp(' ' + badAttributes[i] + '="(.*?)"', 'gi')
        output = output.replace(attributeStripper, '')
      }
      return output
    }
  },

  created () {
    this.isChanging = false
    this.control = null
  },

  mounted () {
    //  initialize the summernote
    if (this.minHeight > this.height) {
      this.minHeight = this.height
    }
    if (this.maxHeight < this.height) {
      this.maxHeight = this.height
    }

    const me = this

    this.control = $(this.$el)

    this.control.summernote({
      lang: this.language,
      height: this.height,
      minHeight: this.minHeight,
      maxHeight: this.maxHeight,
      toolbar: this.toolbar,
      callbacks: {
        onInit () {
          me.control.summernote('code', me.value)
        },
        onChange () {
          if (!me.isChanging) {
            me.isChanging = true
            var code = me.control.summernote('code')
            me.$emit('input', (code === null || code.length === 0 ? null : code))
            // me.value = (code === null || code.length === 0 ? null : code)
            me.$nextTick(() => {
              me.isChanging = false
            })
          }

          // me.$parent.text = code
        },
        onPaste (e) {
          const updatePastedText = function () {
            me.isChanging = true
            const original = me.control.summernote('code')
            // var original = someNote.code();

            const cleaned = me.cleanPastedHTML(original)

            const code = (cleaned === null ? '' : cleaned)
            me.control.summernote('code', code)
            me.isChanging = false

            me.control.summernote('code', code)
          }

          setTimeout(function () {
          // self.$nextTick(() => {
            updatePastedText()
            me.isChanging = false
          }, 50)

          // setTimeout(function () {
          //     //this kinda sucks, but if you don't do a setTimeout,
          //     //the function is called before the text is really pasted.
          //     updatePastedText($self);
          // }, 10);
        }
      }
    })
  },

  watch: {
    model (val) {
      if (!this.isChanging) {
        this.isChanging = true

        var code = (val === null ? '' : val)
        this.control.summernote('code', code)
        this.isChanging = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/RichTextarea.vue